export default __webpack_public_path__ + "static/media/faq-category-icon-4.5256ce60.svg";